import type { ReactNode } from 'react';
import { Breadcrumb, Title, type BreadcrumbItem } from '@chikara/ui';
import styles from './PageContent.module.css';

export interface PageContentProps {
  breadcrumb?: BreadcrumbItem[];
  title?: string;
  subtitle?: string;
  children: ReactNode;
  onBack?: () => void;
  header?: ReactNode;
  button?: ReactNode;
}

export function PageContent({ breadcrumb, title, button, subtitle, children, onBack, header }: PageContentProps) {
  return (
    <div className={styles.pageContent}>
      {breadcrumb && breadcrumb.length > 0 && (
        <div className={styles.breadcrumbContainer}>
          <Breadcrumb items={breadcrumb} onBack={onBack} />
        </div>
      )}
      {header && (
        <div className={styles.headerContainer}>
          {header}
        </div>
      )}
      {title && (
        <div className={styles.titleContainer}>
          <Title button={button} subtitle={subtitle}>{title}</Title>
        </div>
      )}
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
}

PageContent.displayName = 'PageContent';
